import React from "react";
import moment from "moment";

const LateAttTable = ({ empAttData, calculatedAbsents, totalLateCount }) => {

  const tableHead = `py-3 px-3 border-b text-center text-gray-800 font-bold text-[14px] lg:text-lg`;
  const tableBody = `px-3 py-2 border-b font-semibold text-center`;


  return (
    <div className="overflow-x-auto">
      <div className="w-full h-[calc(100vh-20vh)] overflow-y-auto mt-3">
        <table className="min-w-max w-full border border-gray-300">
          <thead className="bg-gray-400 sticky top-0 z-10">
            <tr>
              <th className={tableHead}>Date</th>
              <th className={tableHead}>Entry Time</th>
              <th className={tableHead}>Leaving Time</th>
              <th className={tableHead}>Status</th>
            </tr>
          </thead>
          <tbody>
            {
              empAttData.length == 0 ?
                <tr>
                  <td colSpan={4}>
                    <div className="flex justify-center items-center py-6 text-gray-500 font-semibold text-lg">
                      No Records Available
                    </div>
                  </td>
                </tr>
                : empAttData?.map((employee, empIndex) => (
                  <React.Fragment key={empIndex}>
                    {/* Employee Header Row */}
                    <tr className=" bg-gray-300 text-gray-900 text-center">
                      <td colSpan={4} className="py-2 font-bold text-lg capitalize">
                        {employee.NAME}  ({employee?.DEPTITLE}) {employee?.DEPTGRACETIME}
                      </td>
                    </tr>

                    {/* Attendance Rows */}
                    {employee?.attendanceData?.map((attendance, index) => (
                      <tr
                        key={index}
                        className={`${attendance.late === "Late" ? "bg-yellow-50" : ""
                          }`}
                      >
                        <td className={tableBody}>
                          {attendance.date}

                        </td>
                        <td className={tableBody}>{attendance.entryTime || "-"}</td>
                        <td className={tableBody}>
                          {attendance.leavingTime || "-"}
                        </td>
                        <td className={tableBody}>{attendance.late || "-"}</td>

                      </tr>
                    ))}
                    <tr className="bg-gray-300 text-gray-900 text-center">
                      <td colSpan={2} className="py-2 font-bold  capitalize">
                        Total Late Entries: {totalLateCount} &nbsp; | &nbsp;As per Policy 3 Lates = 1 Absent
                      </td>
                      <td colSpan={2} className="bg-red-300 font-bold">After Calculated Total Absent = {calculatedAbsents}</td>
                    </tr>

                  </React.Fragment>
                ))}
          </tbody>

        </table>
      </div>
    </div>
  );
};

export default LateAttTable;
